/*
 * @Date: 2020-08-28 14:20:36
 * @Author: MX
 * @LastEditTime: 2022-12-19 15:07:54
 * @Description: 
 */
import { post, get } from '@/http/request'
import { APICUS } from "@/constants"
import apiTestMockPost from '@/http/apiTestMock'

//获取图形验证码
export const getCaptcha = () => get(`/${APICUS}/captcha`)
export const isShowSlider = () => get(`/${APICUS}/user/isShowSlider`)
//发送注册短信验证码
export const sendSms = (params) => post(`/${APICUS}/user/sendSms`,params)
//发送注册邮箱验证码
export const sendEmail = (params) => post(`/${APICUS}/email/sendEmail`,params)
//通用短信验证码
export const sendMessage = (params) => post(`/${APICUS}/sms/sendSms`,params)
//注册
export const register = (params) => post(`/${APICUS}/user/register`,params)
//登录
export const login = (params) => post(`/${APICUS}/user/login`,params)
//校验手机与账号
export const checkUserByPhoneOrAccount = (params) => post(`/${APICUS}/user/checkUserByPhoneOrAccount`,params)
//校验手机与账号 - 同时校验
export const checkUserByPhoneOrAccountV2 = (params) => post(`/${APICUS}/user/v2/checkUserByPhoneOrAccount`,params)
//重置密码
export const resetPwd = (params) => post(`/${APICUS}/user/resetPwd`,params)
//获取省市区
export const areaList = (params) => post(`/${APICUS}/area/listV2`,params)
//提交开发者认证
export const devCerCommit = (params) => post(`/${APICUS}/cer/devCerCommit`,params)
//修改开发者认证
export const updateCerCommit = (params) => post(`/${APICUS}/cer/updateInterfaceContactor`,params)
//获取图片完整链接
export const getImgUrl = (params) => get(`/${APICUS}/file/getImgUrl`,params)
//提交企业认证
export const companyCerCommit = (params) => post(`/${APICUS}/cer/companyCerCommit`,params)
//修改企业认证
export const updateCompanyCer = (params) => post(`/${APICUS}/cer/updateCompanyCer`,params)
//接口管理列表
export const getInterfaceList = (params) => get(`/${APICUS}/yl-op-user-interface/list`,params)
//接口申请
export const apply = (params) => post(`/${APICUS}/yl-op-user-interface/apply`,params)
//修改手机号
export const changePhone = (params) => post(`/${APICUS}/user/changePhone`,params)
//查询认证信息
export const getCertificationInfo = (params) => get(`/${APICUS}/cer/certificationInfo`,params)
//停用
export const stopUse = (params) => post(`/${APICUS}/yl-op-user-interface/cancle`,params)
//签名工具/账号秘钥签名
export const accountSign = (params) => post(`/${APICUS}/help-center/accountSign`,params)
//签名工具/json秘钥签名
export const headersSign = (params) => post(`/${APICUS}/help-center/headersSign`,params) 
//上传图片
export const UPLOADUMG = `${process.env.VUE_APP_API_URL}/${APICUS}/file/uploadImg`
//一联模板下载
export const downloadOneTemplate = `${process.env.VUE_APP_API_URL}/${APICUS}/file/downloadOneTemplate`
//二联模板下载
export const downloadTwoTemplate = `${process.env.VUE_APP_API_URL}/${APICUS}/file/downloadTwoTemplate`
//测试api 
export const apiTestApiMock = (params,url) => apiTestMockPost.post(`/${APICUS}${url}`,params) 
//公告 - 分页获取
export const noticePage = (params) => post(`/${APICUS}/notice/webPage`,params)
//公告 - 新闻详情
export const noticeDetail = (params) => get(`/${APICUS}/notice/webDetail`,params)
//控制-调试
export const changeStatus = (params) => post(`/${APICUS}/yl-op-user-interface/changeStatus`,params)
//控制-撤销
export const revoke = (params) => post(`/${APICUS}/yl-op-user-interface/revoke`,params)
// 控制-短信模板管理查询
export const smstemplateSearch = (params) => post(`/${APICUS}/api/sms/getMsgTemplateList`, params)
// 控制-短信模板管理删除
export const smstemplateDel = (params) => post(`/${APICUS}/api/sms/delMsgTemplate`, params)
// 控制-短信模板管理新增
export const smstemplateAdd = (params) => post(`/${APICUS}/api/sms/addMsgTemplate`, params)
// 认证管理信息提交审核（新）
export const platformCerCommit = (params) => post(`/${APICUS}/cer/platformCerCommit`, params)
// 添加应用
export const addApp = (params) => post(`/${APICUS}/yl-op-user-interface/addApp`, params)
// 查询应用详情(解密)
export const appDetails = (params) => post(`/${APICUS}/yl-op-user-interface/appDetails`, params)
// 查询应用列表
export const appList = () => post(`/${APICUS}/yl-op-user-interface/appList`)
// 应用接口列表
export const apiList = (params) => post(`/${APICUS}/yl-op-user-interface/applicationList`, params)
// 应用调试列表
export const managementList = (params) => post(`/${APICUS}/yl-op-user-interface/appManagement`, params)
// 添加接口到应用调试列表
export const addInterface = (params) => post(`/${APICUS}/yl-op-user-interface/addInterface`, params)
// 移除接口
export const removeInterface = (params) => post(`/${APICUS}/yl-op-user-interface/removeInterface`, params)
// 更新新手指引
export const changeGuideStatus = () => post(`/${APICUS}/yl-op-user-interface/changeGuideStatus`)
// 注册类接口联调
export const liantiao = (params) => post(`/${APICUS}/yl-op-user-interface/changeStatus`, params)
// 退出登录
export const logOut = (params) => post(`/${APICUS}/user/logout`, params)

// 获取支付二维码
export const qrApply = (params) => post(`/${APICUS}/api/sms/account/qr/apply`, params)
/**
 * 支付结果查询
 * 10-待支付，15-二维码成功；18-扫码成功；20-支付成功；50-支付失败
 */
export const qrQuery = (params) => post(`/${APICUS}/api/sms/account/qr/query`, params)
// 短信单价查询
export const priceQuery = () => get(`/${APICUS}/api/sms/account/price/query`)
// 短信库存查询
export const stockQuery = (params) => get(`/${APICUS}/api/sms/account/stock/query`, params)
// 购买记录查询
export const qrPage = (params) => post(`/${APICUS}/api/sms/account/qr/page`, params)

// 短信账单统计查询 
export const statisticsQuery = (params) => post(`/${APICUS}/api/sms/account/bill/statistics/query`, params)

// 短信余额预警查询
export const alertQuery = (params) => get(`/${APICUS}/api/sms/account/stock/warn/query`, params)

// 短信余额预警设置
export const setupWarn = (params) => post(`/${APICUS}/api/sms/account/stock/warn`, params)

// 申请调高上限
export const applyLimit = (params) => post(`/${APICUS}/interface/limit/record/apply`, params)

